import React, {
  FC,
  memo,
  useCallback,
} from 'react';
import { useTranslation } from 'react-i18next';
import CopyToClipboard from 'react-copy-to-clipboard';
import { useSelector } from 'react-redux';
import { LocaleKey } from 'utils';
import { PathName } from 'appConstants';
import {
  Image,
  toastSuccess,
} from 'components';
import { WhiteContainer } from 'containers';
import { profileSelectors } from 'store/profile/selectors';
import { banners } from '../instruments';

import styles from '../styles.module.scss';

interface ILangMenu {
  pack: number;
  langBanner: string;
}

export const BannerContainer: FC<ILangMenu> = memo(({
  pack,
  langBanner,
}) => {
  const isHost = window.location.host.includes('test');
  const baseURL = isHost ? PathName.AppUrlTest : PathName.AppUrl;
  const cloudURL = 'https://storage.googleapis.com/eclipse-cdn/images/Banners';
  const { referralCode } = useSelector(profileSelectors.getState);
  const referralLink = `https://agent.eclipse.club/signup?ref=${referralCode}`;

  const { t } = useTranslation('tools');
  const language = langBanner || localStorage.getItem('lng') || LocaleKey.en;

  const onCopy = useCallback((title:string) => {
    toastSuccess(title);
  }, []);

  return (
    <div className={styles.instruments_content}>
      {banners.map(({ title, imgLink }) => {
        const code = `<a
              href="https://eclipse.club/?ref=${referralCode}"
              target="_blank"
              rel="noreferrer"
            >
              <img
                src="${cloudURL}/pack${pack}/${langBanner || language}/${title}.png"
                alt="banner"
              />
            </a>`;

        return (
          <WhiteContainer className={styles.instruments_item}>
            <a
              href={`${baseURL}/banners/pack${pack}/${langBanner || language}/${imgLink}.png`}
              download
              target="_blank"
              rel="noreferrer"
            >
              <Image
                url={`${cloudURL}/pack${pack}/${langBanner || language}/${title}.png`}
                className={styles.instruments_img}
              />
            </a>
            <div className={styles.instruments_title}>
              {title}
            </div>
            <div className={styles.instruments_btn_container}>
              <CopyToClipboard text={referralLink || ''}>
                <button
                  className={styles.instruments_btn}
                  onClick={() => onCopy(t('Link_copied_', { lng: language }))}
                >
                  {t('Instruments_copy_referral_link_', { lng: language })}
                </button>
              </CopyToClipboard>
              <CopyToClipboard text={code || ''}>
                <button
                  className={styles.instruments_btn}
                  onClick={() => onCopy(t('Code_copied_'))}
                >
                  {t('Instruments_show_code_', { lng: language })}
                </button>
              </CopyToClipboard>
            </div>
          </WhiteContainer>
        );
      })}
    </div>
  );
});
